import { render, staticRenderFns } from "./ResTaskProductModal.vue?vue&type=template&id=9d58cc46"
import script from "./ResTaskProductModal.vue?vue&type=script&lang=js"
export * from "./ResTaskProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports